module.exports = __webpack_public_path__ + "img/banner-p.8aff5f6b.png";